import { Link } from 'react-router-dom';

import styles from './adminPage.module.css';
import {MainSectionAdmin} from './main_admin';


export const AdminDashboard = () => {
    
   


    return (
        <div className={styles.adminContainer}>
          
            <header className={styles.adminHeader}>
                <div className={styles.userDashboardLink}>
                    <div>
                        <h1>Admin Dashboard</h1>
                        <p className={styles.subtitle}>Welcome back! Here&apos;s your dashboard overview.</p>
                    </div>
                    <h3>
                        <Link to='/add_expense' className={styles.userDashBtn}>Go To User Dashboard</Link>
                    </h3>
                </div>

                <nav className={styles.adminNav}>
                    <Link to="/admin/users" className={styles.adminLink}>👥 Users</Link>
                    <Link to="/admin/trips" className={styles.adminLink}>✈️ Trips</Link>
                    <Link to="/admin/expenses" className={styles.adminLink}>💰 Expenses</Link>
                    <Link to="/admin/messages" className={styles.adminLink}>💬 Messages</Link>
                    <Link to="/admin/tags" className={styles.adminLink}>🏷️ Tags</Link>
                    <Link to="/admin/email" className={styles.adminLink}>📧 Email Campaigns</Link>
                    <Link to="/admin/analytics" className={styles.adminLink}>📊 Analytics</Link>
                </nav>
            </header>
<MainSectionAdmin />
        </div>
    );
};
